import { createSelector } from '@aptus-financial/react-common-lib';

import { Role } from '@af-fp/api/types.gen';

import { useAuthenticationContext } from './authentication-context';
import { FeatureToggle } from './types';

export const useIsAuthenticationStateLoaded = createSelector(useAuthenticationContext, ([state]) =>
  Boolean(state.loaded),
);

export const useIsLoggedIn = createSelector(useAuthenticationContext, ([state]) => Boolean(state.roles));

export const useIsAdmin = createSelector(useAuthenticationContext, ([state]) =>
  Boolean(state.roles?.includes(Role.Admin)),
);

export const useName = createSelector(useAuthenticationContext, ([state]) => state.name);

export const useEmail = createSelector(useAuthenticationContext, ([state]) => state.email);

export const useFeatureToggle = createSelector(
  useAuthenticationContext,
  ([state], toggle: FeatureToggle): boolean | undefined => {
    if (!state.loaded || !state.featureToggles) {
      return undefined;
    }

    return Boolean(state.featureToggles[toggle]);
  },
);
